export type OptionHighlight = 'none' | 'focused' | 'selected'

export type OptionHighlightState = {
  isDisabled?: boolean
  isFocused?: boolean
  isSelected?: boolean
}

/**
 * react-select carries two independent states per option: `isSelected` is the
 * committed value, `isFocused` is the row the pointer or keyboard is resting
 * on. Both used to resolve to the same background, so any dropdown that
 * already had a value lit up two rows identically and gave no clue which one
 * a click or Enter would commit.
 *
 * Exactly one highlight wins per row: the committed value outranks the cursor
 * so the selected row stays identifiable while the user moves around, and a
 * disabled row never highlights because it cannot be committed at all.
 */
export const getOptionHighlight = ({
  isDisabled,
  isFocused,
  isSelected,
}: OptionHighlightState): OptionHighlight => {
  if (isDisabled) {
    return 'none'
  }

  if (isSelected) {
    return 'selected'
  }

  return isFocused ? 'focused' : 'none'
}
